import { schema as objectiveTypeBasePrincipalAndInterest } from './ObjectiveTypeBasePrincipalAndInterest.schema';
import { schema as objectiveTypeBaseInterestOnly } from './ObjectiveTypeBaseInterestOnly.schema';
import { schema as objectiveTypeBaseInterestInAdvance } from './ObjectiveTypeBaseInterestInAdvance.schema';
import { schema as objectiveTypeBaseLineOfCredit } from './ObjectiveTypeBaseLineOfCredit.schema';
import { labeled } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    principalAndInterest: objectiveTypeBasePrincipalAndInterest(
      Joi,
      labeled(label, 'Principal And Interest -')
    ),
    interestOnly: objectiveTypeBaseInterestOnly(Joi, labeled(label, 'Interest Only -')),
    interestInAdvance: objectiveTypeBaseInterestInAdvance(
      Joi,
      labeled(label, 'Interest In Advance -')
    ),
    lineOfCredit: objectiveTypeBaseLineOfCredit(Joi, labeled(label, 'Line Of Credit -'))
  });

export default {
  schema
};
